<script>
export default {
    name: "About"
}
</script>

<template>
<section class="about">
    <div class="about-cntr">
        <div class="about-left-block">
            <div class="abt-text-cntr">
                <span class="about-block-title">{{__('Поддержка авторов контента')}}</span>
                <p>{{__('Наш маркетплейс ценит труд и талант каждого автора модификаций. На нашей платформе они получают обратную связь от пользователей и зарабатывают на своем контенте')}}</p>
            </div>
            <div class="abt-svg">
                <div class="abt-frst-benefit"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.12499 15.75C0.889489 15.75 0.653989 15.6765 0.449989 15.525C-0.0465107 15.1515 -0.147011 14.4465 0.224989 13.95L3.59999 9.44999C3.84449 9.12599 4.24649 8.95799 4.64699 9.01049C5.05049 9.06449 5.39399 9.32999 5.54399 9.70799L6.15599 11.2395L9.51149 5.08649C9.73049 4.68449 10.1745 4.45949 10.6275 4.50749C11.082 4.55999 11.4615 4.88249 11.583 5.32349L12.675 9.25649L15.867 2.87249C16.146 2.31749 16.821 2.09399 17.376 2.36999C17.9325 2.64899 18.1575 3.32399 17.8785 3.87899L13.3785 12.879C13.17 13.296 12.72 13.536 12.264 13.4955C11.8005 13.4505 11.4135 13.125 11.289 12.6765L10.1565 8.60099L6.98549 14.415C6.77699 14.7975 6.36749 15.036 5.93099 14.9985C5.49599 14.973 5.11499 14.6985 4.95299 14.2935L4.19699 12.402L2.02349 15.3015C1.80299 15.5955 1.46399 15.7515 1.12199 15.7515L1.12499 15.75Z" fill="white"/>
                </svg>
                    {{__('+456 подписчиков')}}</div>
                <div class="abt-scnd-benefit"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_369_172)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7831 4.54606C13.1759 3.13717 10.8619 3.7033 10.012 5.45328C9.8237 5.84099 9.43045 6.08705 8.99944 6.08682C8.56843 6.0866 8.17543 5.84015 7.98754 5.45224C7.85146 5.17132 7.67464 4.91529 7.46198 4.69179C6.31329 3.48189 4.3998 3.4321 3.19147 4.58034C1.98238 5.72826 1.93235 7.63948 3.07823 8.84795L9.00076 15.0003L14.9244 8.84521C14.9363 8.83285 14.9485 8.8208 14.9609 8.80905C15.6271 8.07922 15.9308 7.02569 15.6429 5.9302C15.5046 5.40318 15.1984 4.91115 14.7831 4.54606ZM16.4977 10.4552L10.5936 16.5899C9.72458 17.4925 8.27707 17.495 7.40742 16.5894L1.44948 10.4003C-0.555159 8.29075 -0.46919 4.95366 1.64155 2.94931M16.4977 10.4552C16.5164 10.438 16.5347 10.42 16.5524 10.4014C17.7722 9.11656 18.3145 7.2443 17.8191 5.35866C17.5646 4.38896 17.0129 3.51002 16.2675 2.85516C14.0072 0.873459 10.8688 1.17648 9.00002 3.04633C6.98693 1.02861 3.71899 0.975557 1.64155 2.94931M8.33503 3.86124C8.20776 4.05382 8.09165 4.25701 7.98804 4.47037L9.00001 4.96182L10.0125 4.47141C9.77662 3.98445 9.46755 3.53558 9.09232 3.14115L8.33503 3.86124Z" fill="white"/>
                        <path d="M8.33503 3.86124C8.20776 4.05382 8.09165 4.25701 7.98804 4.47037L9.00001 4.96182L10.0125 4.47141C9.77662 3.98445 9.46755 3.53558 9.09232 3.14115L8.33503 3.86124Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_369_172">
                            <rect width="18" height="18" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                     {{__('35 людям понравилось')}}</div>
                <div class="abt-thrd-benefit">{{__('12 056 ₽')}}</div>
                <img src="@/assets/icons/around.svg" class="abt-around">
            </div>
        </div>
        <div class="about-right-block">
            <div class="abt-text-cntr">
                <span class="about-block-title">{{__('Тесная связь с комьюнити')}}</span>
                <p>{{__('Мы прислушиваемся к нашим пользователям и выпускаем актуальные и желаемые игроками модификации, чтобы обеспечить максимально комфортную игру с Cloud Mods')}}</p>
            </div>
        </div>
    </div>
</section>
</template>

<style scoped>
.about {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        background-repeat: no-repeat;
        background-position: center;
}

.about-cntr {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.about-left-block, .about-right-block {
    background: var(--bg-secondary);
}

.abt-text-cntr {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.about-block-title {
    color: var(--text-primary);
    font-style: normal;
    font-weight: 700;
}

p {
    color: var(--text-secondary);
    font-weight: 600;
    margin: 0;
}

.abt-frst-benefit, .abt-scnd-benefit, .abt-thrd-benefit{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: rgba(18, 18, 18, 0.80);
    backdrop-filter: blur(17px);
    color: var(--text-primary);
    font-weight: 600;
}

@media (min-width: 320px) {

}

@media (min-width: 464px) {

}

@media (min-width: 744px) {

}

@media (min-width: 984px) {

}

@media (min-width: 1248px) {
    .about {
        height: 298px;
    }

    .about-cntr {
        gap: 18px;
    }

    .about-left-block {
        width: 817px;
        height: 226px;

        border-radius: 20px;
    }

    .about-right-block {
        width: 413px;
        height: 226px;

        border-radius: 20px;
    }

    .abt-text-cntr {
        margin-top: 30px;
        margin-left: 30px;

        position: absolute;
        gap: 18px;
    }

    .about-block-title {
        font-size: 24px;
    }

    p {
        width: 366px;
        font-size: 16px;
    }

    .abt-svg {
        position: relative;

        width: 344px;
        height: 136px;

        display: flex;
        align-items: center;
        justify-content: center;

        margin-top: 45px;
        margin-left: 443px;
    }

    .abt-frst-benefit, .abt-scnd-benefit, .abt-thrd-benefit {
        position: absolute;
        padding: 12px 16px;
        gap: 10px;
        border-radius: 14px;
    }

    .abt-frst-benefit {
        margin-left: 113px;
        top: 0px;
    }

    .abt-scnd-benefit {
        left: 0px;
        top: 58px;
    }

    .abt-thrd-benefit {
        margin-left: 249px;
        margin-top: 90px;
    }

    .abt-around {
        width: 226px;
        height: 108px;
    }
}
</style>